export const getUserValues = (
  data: { id: string, email: string, displayName: string; roles: { id: number; type: number }[] },
) => ({
  id: data?.id || '',
  name: data?.displayName || '',
  user: [{
    value: data?.id || '',
    label: data?.displayName || '',
    key: data?.email || '',
  }],
  email: data?.email || '',
  roles: (data?.roles ?? []).map((role) => role.type),
});